import { Price } from "../redux/types/types";

/**
 * Sorts prices for user display:
 * 1. General packages first (sorted by numberOfClasses ascending)
 * 2. Special packages second (sorted by numberOfClasses ascending)
 */
export const sortPricesForDisplay = (prices: Price[]): Price[] => {
  return prices.sort((a, b) => {
    // First, separate general and special packages
    const aIsSpecial = !!a.specialType;
    const bIsSpecial = !!b.specialType;

    // If one is general and one is special, general comes first
    if (!aIsSpecial && bIsSpecial) return -1;
    if (aIsSpecial && !bIsSpecial) return 1;

    // If both are the same type (both general or both special), sort by numberOfClasses
    return a.numberOfClasses - b.numberOfClasses;
  });
};
